import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { TendersTableRow } from './components/TendersTableRow';
import type { TenderDto } from './types/TenderDto';
import { KeyedRow } from '../../components/KeyedRow';

export function Tenders() {
	const { organisation } = useParams();
	const filter = useFilter();
	const pagination = usePagination();

	const tendersQuery = queryWithFilterAndPages<TenderDto[]>(
		`${organisation}/tenders`,
		filter.value,
		pagination.value,
	);

	const tendersCountQuery = queryWithFilter<number>(
		`${organisation}/tenders/count`,
		filter.value,
		true,
	);

	return (
		<>
			<PageHeader title={'Tenders'} filter={filter} />
			<DataTable
				pagination={pagination}
				totalItems={tendersCountQuery.data?.value ?? 100}
				isRowsLoading={tendersQuery.isLoading}
				isPaginationLoading={tendersCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th><Title label={'Identifier'} /></Table.Th>
						<Table.Th miw={145}><Title label={'Date'} /></Table.Th>
						<Table.Th><Title label={'Time'} /></Table.Th>
						<Table.Th><Title label={'Type'} /></Table.Th>
						<Table.Th><Title label={'Amount'} /></Table.Th>
						<Table.Th><Title label={'Change'} /></Table.Th>
						<Table.Th><Title label={'Currency Code'} /></Table.Th>
						<Table.Th><Title label={'Report No'} /></Table.Th>
						<Table.Th><Title label={'Receipt'} /></Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{tendersQuery.data?.value.map((element) => (
						<TendersTableRow key={element.id} tender={element} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
